<template>
  <div v-if="difference">
    <div>
      <p>{{ time_helper.makeTwoChars(difference.hours()) + ':' + time_helper.makeTwoChars(difference.minutes()) }}</p>
    </div>
    <p :class="{ green_text: difference.asHours() > work_hours, red_text: difference.asHours() < work_hours }">{{getWorkHoursDifference}}</p>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
export default {
  name: 'presence-report-total-hours',
  props: ['payload'],
  data () {
    let time_helper = new TimeHelper()
    return {
      time_helper,
      work_hours: 9,
      difference: undefined
    }
  },
  created () {
    this.setDifference()
  },
  watch: {
    payload: {
      handler () {
        this.setDifference()
      },
      deep: true
    }
  },
  computed: {
    getWorkHoursDifference () {
      return this.time_helper.convertDecimalHoursToTime(Math.abs(this.work_hours - this.difference.asHours()))
    }
  },
  methods: {
    setDifference () {
      if (this.payload.login.value == undefined || this.payload.logout == undefined || this.payload.logout == '') {
        this.difference = undefined
        return
      }
      this.difference = this.time_helper.getTimeDifference(this.payload.login.value, this.payload.logout.value)
    }
  }
}
</script>
<style scoped>
  .green_text{
    color: green;
  }
  .red_text{
    color: red;
  }
</style>
